<template>
  <div 
    class="limittime-receive-container" 
    :style="{
      'background-image': `url(${gc.section_bg.top}), url(${gc.section_bg.mid}), url(${gc.section_bg.bot})`,
      'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
      'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
    }"
  >
    <div class="time-list-wrapper">
      <div class="time-list-scroll">
        <div 
          class="scroll-inner"
          :style="{
            width: 67 * awards.length + 10 * (awards.length - 1) + 24 + 'px'
          }"
        >
          <div 
            v-for="item in awards"
            :key="item.day_time"
            class="time-item"
            :class="{
              'active': item.state == '1'
            }"
            :style="{
              'background': item.state == '-1' || item.state == '3' ? 'rgba(0, 0, 0, 0.2)' : item.state == '0' ? 'rgba(0, 0, 0, 0.03)' : gc.main_color,
              'border': `1px solid ${(selectedDayTime == item.day_time || item.state == 1) ? gc.main_color : 'rgba(0, 0, 0, 0)'}`,
              'color': item.state == '0' ? gc.font_color : item.state == '-1' ? 'rgba(255,255,255, 0.7)' : '#FFFFFF'
            }"
            @click="selectedDayTime = item.day_time"
          >
            <div class="time-inner">
              <p class="date">{{ item.day_time | formatTime }}</p>
              <p class="time-desc">{{ dayStateDesc[item.state] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="receive-list-wrapper">
      <div 
        class="receive-item" 
        v-for="(award, index) in currentAwardsList"
        :key="award.award_id"
      >
        <div class="item-image-box" @click="previewImage(index)">
          <img class="item-image" :src="award.cover_img" alt="">
          <div class="btn-click-preview" :style="{'background-color': gc.main_color}">
            <p>点击预览</p>
          </div>
        </div>
        <div class="item-info-box">
          <p class="item-name" :style="{color: gc.font_color}">{{ award.title }}</p>
          <div class="countdown-box" v-if="award.state == '0' || award.state == '1'">
            <span class="block" :style="{'color': gc.main_color}">{{ getTimeNumber(award, 'day') }}</span>
            <span class="day">天</span>
            <span class="block" :style="{'color': gc.main_color}">{{ getTimeNumber(award, 'hour') }}</span>
            <span class="ch">:</span>
            <span class="block" :style="{'color': gc.main_color}">{{ getTimeNumber(award, 'minute') }}</span>
            <span class="ch">:</span>
            <span class="block" :style="{'color': gc.main_color}">{{ getTimeNumber(award, 'second') }}</span>
            <span class="desc" :style="{'color': gc.font_color}" >{{ award.state == '0' ? '开始' : '领取' }}倒计时</span>
          </div>
          <div 
            class="rest-box"
            :style="{
              'background-image': award.state == '-1' || award.state == '-2' ? 'none' : `linear-gradient(272deg, ${gc.main_color} 0, ${hexToRgba(gc.main_color, 0.12)} 66px, ${hexToRgba(gc.main_color, 0)} 90px)`,
              'margin-top': award.state == '0' || award.state == '1' ? '18px' : '42px'
            }"
          >
            <div class="rest-progress">
              <div 
                class="progress-bar" 
                :style="{
                  'background-color': gc.main_color, 
                  'width': award.state == '-1' || award.state == '-2' ? '0%' : `${award.remain_cnt / award.all_cnt * 100}%`
                }"
              ></div>
            </div>
            <p 
              class="rest-count" 
              :style="{'color': gc.main_color}"
            >{{ award.state == '1' ? `仅剩${award.remain_cnt}个` : award.state == '0' ? '未开启' : award.state == '2' ? '已领取' : '已结束'}}</p>
            <div 
              class="btn-receive"
              :class="{
                'disable': award.state == '0' || award.state == '2'
              }"
              @click="receive(award, index)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="67" height="32" viewBox="0 0 67 32" fill="none">
                <path d="M8 0H62C64.7614 0 67 2.23858 67 5V27C67 29.7614 64.7614 32 62 32H0L8 0Z" :fill="award.state == '-1' || award.state == '-2' ? '#C6C6C6' : gc.main_color"/>
              </svg>
              <p 
                :style="{
                  'color': award.state == '-1' || award.state == '-2' ? 'rgba(255,255,255,0.75)' : gc.text_color
                }"
              >{{ awardStateDesc[award.state] }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal ref="notify-modal" :width="299" :gc="gc" :cc="cc" title="领取成功">
      <div class="receive-modal-wrapper modal-content">
        <p 
          class="notify"
          :style="{
            'color': hexToRgba(gc.main_color, .8)
          }"
        >{{ notify }}</p>
      </div>
    </Modal>
  </div>
</template>

<script>
import { formatDateByTemplet, executeProtocol } from '_lib/utils'
import { getTimelyCollectionAward } from '_api/activity-common-template'
import { ComponentCommonMixin } from '../mixin'

export default {
  name: 'limittime-receive-container',
  mixins: [ ComponentCommonMixin ],
  data () {
    return {
      currentDayTime: new Date().setHours(0, 0, 0, 0) / 1000,
      selectedDayTime: -1,
      dayStateDesc: {
        '-1': '已结束',
        '0': '即将开放',
        '1': '可领取',
        '2': '已结束', // 已领完
        '3': '可领取' // 非当天，但仍可领取
      },
      awardStateDesc: {
        '-2': '无库存',
        '-1': '已结束',
        '0': '即将开放',
        '1': '领取',
        '2': '已领取'
      },
      currentPreviewIndex: -1,
      notify: '',
      awards: []
    }
  },
  computed: {
    currentAwardsList () {
      let list = this.awards.find((item) => {
        return item.day_time == this.selectedDayTime
      })
      if (list) {
        list.awards.forEach((award) => {
          let begin = Number(award.begin_count_down)
          let end = Number(award.end_count_down)

          award.state = this.getAwardState(award.collected, award.remain_cnt, begin, end)
        })
        return list.awards
      }
      
      return []
    },
    selectedDayTimeIndex () {
      return this.awards.findIndex((list) => {
        return list.day_time === this.selectedDayTime
      })
    }
  },
  created () {
    this.awards = JSON.parse(JSON.stringify(this.cd.awards))
    this.initData()
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.interval = null
  },
  watch: {
    'cd.awards' () {
      this.awards = JSON.parse(JSON.stringify(this.cd.awards))
      this.initData()
    }
  },
  methods: {
    initData () {
      this.awards.forEach((day) => {
        day.state = this.getDayState(day)
        if (day.state == 1) {
          this.selectedDayTime = day.day_time
        }
      })

      if (this.selectedDayTime === -1) {
        this.selectedDayTime = this.awards[0].day_time
      }

      this.initCountDown()
    },
    receive (award, award_index) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if (award.state != '1') {
        return
      }
      if (this.lock) {
        return
      }
      this.lock = true

      getTimelyCollectionAward({
        award_id: award.award_id
      }).then((res) => {
        this.lock = false
        if (res.data.status === 'ok') {
          this.notify = res.data.result.notify_content

          this.$refs['notify-modal'].showModal()

          this.$set(this.awards[this.selectedDayTimeIndex].awards[award_index], 'collected', true)
        }
      })
    },
    getTimeNumber (award, type) {
      if (award.state != '1' && award.state != '0') {
        return '00'
      }
      let second = Number(award.begin_count_down) || Number(award.end_count_down)
      var seconds = second % 60
      var minutes = Math.floor(second / 60) % 60
      var hours = Math.floor(Math.floor(second / 60) / 60) % 24
      var days = Math.floor(Math.floor(Math.floor(second / 60) / 60) / 24)
      var num = 0
      switch (type) {
        case 'day':
          num = ('' + days).length === 1 ? '0' + days : days
          break;
        case 'hour':
          num = ('' + hours).length === 1 ? '0' + hours : hours
          break;
        case 'minute':
          num = ('' + minutes).length === 1 ? '0' + minutes : minutes
          break;
        case 'second':
          num = ('' + seconds).length === 1 ? '0' + seconds : seconds
          break;
      }
      return num
    },
    initCountDown () {
      clearInterval(this.interval)
      this.interval = null
      this.interval = setInterval(() => {
        this.awards.forEach((list, index) => {
          list.awards.forEach((award, award_index) => {
            let begin = Number(award.begin_count_down)
            let end = Number(award.end_count_down)

            if (begin > 0) {
              this.$set(this.awards[index].awards[award_index], 'begin_count_down', --begin)
            }
            if (end > 0) {
              this.$set(this.awards[index].awards[award_index], 'end_count_down', --end)
            }

            award.state = this.getAwardState(award.collected, award.remain_cnt, begin, end)
          })
        })
      }, 1000)
    },
    getAwardState (collected, remain_cnt, begin, end) {
      if (collected) {
        return '2'
      } else if (begin > 0) {
        return '0'
      } else if (begin === 0 && end > 0) {
        if (remain_cnt > 0) {
          return '1'
        } else {
          return '-2'
        }
      } else {
        return '-1'
      }
    },
    getDayState (day) {
      let hasCanCollectAward = day.awards.find((award) => {
        return Number(award.end_count_down) > 0
      })
      if (!hasCanCollectAward) {
        return -1
      }
      if (day.day_time == this.currentDayTime) {
        if (hasCanCollectAward) {
          return 1
        } else {
          return 2
        }
      } else if (day.day_time > this.currentDayTime) {
        return 0
      } else {
        if (hasCanCollectAward) {
          return 3
        } else {
          return -1
        }
      }
    },
    previewImage (index) {
      executeProtocol({
        protocol_type: 'imagePreview',
        image_urls: this.currentAwardsList[index].detail_img + '?imageMogr2/quality/70',
        index: 0
      })
    }
  },
  filters: {
    formatTime (timestamp) {
      let str = formatDateByTemplet(timestamp, 'mm-dd').replace('-', '月') + '日'
      return str.startsWith('0') ? str.slice(1) : str
    }
  }
}
</script>

<style lang="less">
.limittime-receive-container {
  padding: 18px 0 20px;
  margin: 0 14px;
  background-size: 100% 30px, 100% calc(100% - 60px), 100% 30px;
  background-repeat: no-repeat;
  background-position: center top, center center, center bottom;
  .receive-list-wrapper {
    width: 100%;
    padding: 0 18px;
    .receive-item {
      width: 100%;
      height: 114px;
      margin-top: 20px;
      display: flex;
      &:first-of-type {
        margin-top: 18px;
      }
      .item-image-box {
        width: 114px;
        height: 114px;
        border-radius: 5px;
        overflow: hidden;
        background-color: rgba(0, 0, 0, 0.03);
        position: relative;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .btn-click-preview {
          width: 44px;
          height: 15px;
          border-radius: 3px;
          position: absolute;
          bottom: 0;
          left: 0;
          p {
            width: 200%;
            height: 200%;
            line-height: 30px;
            text-align: center;
            transform: scale(0.5);
            transform-origin: 0 0;
            color: #FFF;
          }
        }
      }
      .item-info-box {
        width: 0;
        flex: 1;
        height: 100%;
        margin-left: 10px;
        .item-name {
          margin-top: 10px;
          line-height: 20px;
          font-size: 14px;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .countdown-box {
          height: 20px;
          margin-top: 4px;
          display: flex;
          .block {
            width: 18px;
            height: 20px;
            display: block;
            border-radius: 2px;
            text-align: center;
            line-height: 20px;
            background-color: rgba(#000, 0.05);
            font-size: 12px;
          }
          .day {
            width: 12px;
            line-height: 20px;
            font-size: 8px;
            color: rgba(#000, 0.5);
            text-align: center;
          }
          .ch {
            width: 7px;
            line-height: 20px;
            font-size: 8px;
            color: rgba(#000, 0.5);
            text-align: center;
          }
          .desc {
            margin-left: 6px;
            line-height: 20px;
            font-size: 10px;
          }
        }
        .rest-box {
          width: 100%;
          height: 32px;
          padding-left: 8px;
          margin-top: 18px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          background-color: rgba(#000, 0.03);
          .rest-progress {
            width: 50px;
            height: 4px;
            border-radius: 2px;
            background-color: rgba(#000, 0.05);
            .progress-bar {
              height: 4px;
              border-radius: 2px;
            }
          }
          .rest-count {
            margin-left: 6px;
            line-height: 16px;
            font-size: 10px;
          }
          .btn-receive {
            width: 67px;
            height: 32px;
            padding-left: 3px;
            margin-left: auto;
            position: relative;
            &.disable {
              opacity: 0.5;
            }
            svg {
              position: absolute;
              bottom: 0;
              right: 0;
            }
            p {
              width: 100%;
              text-align: center;
              line-height: 32px;
              font-size: 12px;
              font-weight: 600;
              position: relative;
              z-index: 1;
            }
          }
        }
      }
    }
  }
  .time-list-wrapper {
    width: 100%;
    height: 40px;
    overflow: hidden;
    .time-list-scroll {
      width: 100%;
      height: 80px;
      overflow-y: hidden;
      .scroll-inner {
        height: 40px;
        padding: 0 12px;
        display: flex;
      }
      .time-item {
        width: 67px;
        height: 40px;
        margin-left: 10px;
        border-radius: 3px;
        position: relative;
        &:first-of-type {
          margin-left: 0;
        }
        &.active {
          .time-inner {
            .date {
              font-weight: 600;
            }
          }
        }
        .time-inner {
          width: 200%;
          height: 200%;
          position: absolute;
          top: 0;
          left: 0;
          transform: scale(0.5);
          transform-origin: 0 0;
          .date {
            margin-top: 12px;
            line-height: 32px;
            text-align: center;
            font-size: 24px;
          }
          .time-desc {
            margin-top: 2px;
            line-height: 22px;
            text-align: center;
            font-size: 16px;
          }
        }
      }
    }
  }
}
.receive-modal-wrapper {
  .notify {
    line-height: 20px;
    font-size: 12px;
    text-align: center;
  }
}
</style>